// extracted by mini-css-extract-plugin
module.exports = {"container":"AnswerList_container__1e05_","off":"AnswerList_off__hFdu0"};